import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'baseIndex',
		redirect: '/',
		component: resolve => require(['@/views/base/index'], resolve),
		children: [
			{
				path: '/',
				name: 'homeIndex',
				component: resolve => require(['@/views/homeIndex/index'], resolve)
			},
			{
				path: 'mall',
				name: 'mall',
				component: resolve => require(['@/views/mall/index'], resolve)
			},
			{
				path: 'aboutUs',
				name: 'aboutUs',
				component: resolve => require(['@/views/aboutUs/index'], resolve)
			},
		]
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
function isPhone() {
	if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)))
		return true;
	return false;
}
router.beforeEach((to, from, next) => {
	// var isMobile = isPhone();
	// var params1 = to.query.custom,
	// 	params2 = to.query.cardBookletId;
	// if(params1) {
	// 	sessionStorage.setItem('gift_mobile_custom', params1)
	// }
	// if(params2) {
	// 	sessionStorage.setItem('gift_mobile_cardBookletId', params2)
	// }
	next();
})
//after 钩子没有next 方法，不能改变导航
router.afterEach((to, from) => {})
export default router